import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchPlaceholder: {
		id: 'home.tabs.boards.filter.search-placeholder',
		defaultMessage: 'Search boards',
		description: 'Placeholder to be displayed for the search input on For You page Boards Tab',
	},
});
export default messages;
